import { render, staticRenderFns } from "./block-privat-bank-first-document-error.vue?vue&type=template&id=67a6e046&scoped=true&lang=pug&"
import script from "./block-privat-bank-first-document-error.vue?vue&type=script&lang=js&"
export * from "./block-privat-bank-first-document-error.vue?vue&type=script&lang=js&"
import style0 from "./block-privat-bank-first-document-error.vue?vue&type=style&index=0&id=67a6e046&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a6e046",
  null
  
)

export default component.exports